import { MarkerDimension } from '../case/case.state'

export interface DomainInfo {
    lowerBound: number
    upperBound: number
}

export interface DimensionDataWithDomain {
    domain: DomainInfo
    points: [number, number][]
    legend: { key: number; value: string }[] | undefined
}

export interface PlotDataState {
    markerX: MarkerDimension | null
    markerY: MarkerDimension | null
    markerColor: MarkerDimension | null
    isLoadingPlotData: boolean
    pointSize: number
    pointOpacity: number
    lassoType: string
}

export enum PlotAxis {
    X,
    Y,
    COLOR,
}
